import trackSneakerFirst from '../../../assets/images/track-sneaker-first.png';
import trackSneakerSecond from '../../../assets/images/track-sneaker-second.png';
import trackSneakerThrid from '../../../assets/images/track-sneaker-thrid.png';

export const newnessData = [
    {
        title: "TRACK SNEAKER IN WHITE/FLUO PINK",
        sizes: [38, 39, 40, 41, 42, 43, 44],
        image: trackSneakerFirst
    },
    {
        title: "TRACK SNEAKER IN WHITE/FLUO PINK",
        sizes: [38, 39, 40, 41, 42, 43, 44],
        image: trackSneakerSecond
    },
    {
        title: "TRACK SNEAKER IN WHITE/FLUO PINK",
        sizes: [38, 39, 40, 41, 42, 43, 44],
        image: trackSneakerThrid
    },
    {
        title: "TRACK SNEAKER IN WHITE/FLUO PINK",
        sizes: [38, 39, 40, 41, 42, 43, 44],
        image: trackSneakerThrid
    }
]